import { ActionContext, ActionTree } from "vuex";
import { StoreState } from "@/store/type";
import {
  IQuotationManagementState,
  SurchargesPayload,
} from "@/core/interfaces/state/quotationManagmentState.interface";
import QuotationService from "../services/manageQuotation.service";
import { StatusCodes } from "http-status-codes";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_MESSAGES } from "@/core/constants/notificationMessages";
import { ICoreErrorResponse } from "@/core/interfaces/coreResponse.interface";

const actions: ActionTree<IQuotationManagementState, StoreState> = {
  async applySurcharge(
    context: ActionContext<IQuotationManagementState, StoreState>,
    payload: SurchargesPayload,
  ) {
    try {
      const quotationService = new QuotationService();
      const response: ICoreErrorResponse =
        await quotationService.applySurcharges(payload);

      if (response.success && response.status === StatusCodes.OK) {
        context.commit("saveUpdatedFareOptions", response.data?.data);
        notificationService.type = NOTIFICATION_TYPES.SUCCESS;
        notificationService.description =
          NOTIFICATION_MESSAGES.APPLY_SURCHARGE_SUCCESS;
      } else {
        throw response;
      }
    } catch (error) {
      const exception = error as ICoreErrorResponse;

      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description =
        exception.message ||
        exception.error ||
        NOTIFICATION_MESSAGES.APPLY_SURCHARGE_FAILURE;
    }
    notificationService.triggerNotification();
  },
};

export default actions;
